import {MenuItem, Select} from '@mui/material';
import {useField} from 'formik';
import {notEmpty} from 'main/utility/CommonUtil';
import {getFieldLabel} from 'main/utility/LayoutUtil';
import PropTypes from 'prop-types';

const AppOptFldSelectList = (props) => {
  const {
    options,
    label,
    required,
    labelid,
    multivalue: isMulti,
    readonly,
  } = props;
  const [field] = useField(props);

  const hasOptions = notEmpty(options);
  const fieldLabel = getFieldLabel(label, required);
  const displayValue = hasOptions ? field.value : isMulti ? [] : '';

  return (
    <Select
      {...field}
      value={displayValue}
      labelId={labelid}
      label={fieldLabel}
      multiple={isMulti}
      readOnly={readonly}
    >
      {hasOptions &&
        options.map((option) => (
          <MenuItem key={`${field.name}:${option.value}`} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </Select>
  );
};

AppOptFldSelectList.propTypes = {
  label: PropTypes.string,
  labelid: PropTypes.string,
  required: PropTypes.bool,
  multivalue: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  readonly: PropTypes.bool,
};

export default AppOptFldSelectList;
